import BasePage from "pages/base_page"
import React from "react"
import { createRoot } from "react-dom/client"
import PodcastListenAndSubscribe from "containers/PodcastListenAndSubscribe"

class PodcastShowPage extends BasePage {
  constructor(options) {
    super()

    this.initListenAndSubscribe(options)
  }

  initListenAndSubscribe(options) {
    if (document.getElementById("podcast-listen-and-subscribe")) {
      const domContainer = document.createElement("div")
      const subscriptionOptions = document.getElementById("podcast-listen-and-subscribe")
      subscriptionOptions.parentNode.insertBefore(domContainer, subscriptionOptions)

      const container = React.createElement(PodcastListenAndSubscribe, options)
      const root = createRoot(domContainer)
      root.render(container)
    }
  }
}

export default PodcastShowPage
